<script setup lang="ts"></script>

<template>
  <div class="blank-layout">
    <slot />
  </div>
</template>

<style scoped>
.blank-layout {
  min-height: 100vh;
  display: flex;
  background: var(--cream-50, #fbf8f1);
}
</style>
